import { LoginInfo } from "./LoginInfo";
export default LoginInfo;



// WEBPACK FOOTER //
// ./src/components/atomic/molecules/LoginInfo/index.js